import type { CloudRuntime } from '@/lib/cloud-runtime/cloud-runtime';

/**
 * A live view's socket of the cloud sandbox, beside its workspace socket: same control plane,
 * same session token (sent in a first `hello` frame), then the view's own protocol: RFB for the
 * desktop (noVNC), JSON for the browser.
 */
export function cloudViewUrl(
  runtime: Pick<CloudRuntime, 'url'>,
  view: 'display' | 'browser',
): string {
  const url = new URL(runtime.url);
  url.pathname = url.pathname.replace(/\/workspace$/, `/${view}`);
  return url.toString();
}
